import { render, staticRenderFns } from "./AI-attendance.vue?vue&type=template&id=b88d8178"
import script from "./AI-attendance.vue?vue&type=script&lang=js"
export * from "./AI-attendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports